import React, { useState, useContext, useRef, useEffect, useMemo, memo } from "react";
import PropTypes from "prop-types";
import Select from "react-select";
import { styles, handleBusOnEnter, navigateToCell, startsWithFilter } from "./shared.js";
import "./Renderables.css";

export const RenderBusEditable = memo(({
  value: initialValue,
  row,
  rowCount,
  column,
  onCellInputBlur,
  TableContext,
  viewOnly,
}) => {
  const vehiclesData = useContext(TableContext);
  const { index } = row;
  const { id } = column;
  const busOptions = useMemo(
    () => vehiclesData.duplicateVehicles.map((member) => ({
      label: member.equipNo,
      value: member.equipNo,
    })),
    [vehiclesData.duplicateVehicles]
  );
  const [optionListIsOpen, setOptionListIsOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState(initialValue);
  const selectBusRef = useRef(null);

  const busStyles = useMemo(() => ({
    ...styles,
    container: (base) => ({
      ...styles.container(base),
      minWidth: "80px",
    }),
  }), []);

  useEffect(() => {
    setSelectedValue(initialValue);
  }, [initialValue]);

  useEffect(() => {
    if (optionListIsOpen) {
      const optionList = document.querySelector(`[role="listbox"]`);
      if (optionList) {
        // Calculate the position of the listbox bottom relative to the viewport
        if (optionList.getBoundingClientRect().bottom > window.innerHeight) {
          optionList.scrollIntoView({
            behavior: "smooth",
            block: "end",
            inline: "nearest",
          });
        }
      }
    }
  }, [optionListIsOpen]);

  return (
    <Select
      ref={selectBusRef}
      placeholder={""}
      value={
        selectedValue ? { label: selectedValue, value: selectedValue } : null
      }
      options={busOptions}
      name="cars"
      id={`${id}-${index}`}
      styles={busStyles}
      isDisabled={viewOnly}
      filterOption={startsWithFilter}
      onMenuOpen={() => setOptionListIsOpen(true)}
      onMenuClose={() => setOptionListIsOpen(false)}
      onChange={(e) => {
        setSelectedValue(e.value);
        onCellInputBlur(e.value, index, id, row);
      }}
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          handleBusOnEnter(index);
        } else if (e.key === "Delete" || e.key === "Backspace") {
          if (!e.target.value) {
            setSelectedValue("");
            onCellInputBlur("", index, id, row);
          }
        } else if (["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].includes(e.key)) {
          e.preventDefault();
          navigateToCell(id, index, e.key, rowCount);
        }
      }}
    />
  );
});

RenderBusEditable.displayName = "RenderBusEditable";

RenderBusEditable.propTypes = {
  value: PropTypes.string,
  row: PropTypes.shape({
    index: PropTypes.number.isRequired,
  }).isRequired,
  rowCount: PropTypes.number.isRequired,
  column: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
  onCellInputBlur: PropTypes.func.isRequired,
  TableContext: PropTypes.object.isRequired,
  viewOnly: PropTypes.bool.isRequired,
};
